import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';

import { Dialog, DialogContent } from 'components/ui/dialog';

export default function Spinner({ isSpinning }: { isSpinning: boolean }) {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setOpen(isSpinning);
  }, [isSpinning]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        onInteractOutside={(e) => e.preventDefault()}
        onOpenAutoFocus={(e) => e.preventDefault()}
        hideClose
        className='bg-transparent border-none shadow-none w-fit max-w-fit'
        overlayClassName='backdrop-blur-sm'
      >
        <Loader2
          className='w-10 h-10 stroke-1 text-primary animate-spin'
          role='spinbutton'
        />
      </DialogContent>
    </Dialog>
  );
}
